import BaseAPI from "./BaseAPI";

class TenantAPI extends BaseAPI {
	
    getAll = async () => {
        var promise = await this.init().get("/account/tenants");
        return promise;
    };

    getAllForSuperuser = async () => {
        var promise = await this.init().get("/account/super_tenants");
        return promise;
    };

    getTenantForSuperuser = async (key, withOverview = false) => {
        let url = "/account/super_tenants/"+key;
        if(withOverview) {
            url += "?overview=true"
        }
        var promise = await this.init().get(url); 
        return promise;
    };

    getNewTenantForSuperuser = async (key, withOverview = false) => {
        let url = "/account/super_tenants/0";
        if(withOverview) {
            url += "?overview=true"
        }
        var promise = await this.init().get(url); 
        return promise;
    };

    dropboxAuthoriseWithCode= async (tenantKey,dropboxCode) => {
        var promise = null;
        promise = await this.init().get("/account/super_tenants/"+tenantKey+"/authorisedropbox/"+dropboxCode);
        return promise;
    };

    switchTenant = async (tenantId) => {
        var promise = await this.init().get("/account/tenant/"+tenantId, {});
        return promise;
    };

    saveTenant = async (data) => {
        let dataObj = data; //data.getData(); //data.toJsonString();
        var promise = await this.init().post("/account/tenant/create", dataObj);
        return promise;
    };

    disconnectDropboxAccount= async (tenantKey) => {
        var promise = null;
        promise = await this.init().get("/account/super_tenants/"+tenantKey+"/disconnect");
        return promise;
    };    

    updateDropboxAccount= async (tenantKey, data) => {
        var promise = null;
        promise = await this.init().post("/account/super_tenants/"+tenantKey.trim()+"/upd_dropbox", data);
        return promise;
    };    

    deleteTenant= async (tenantKey) => {
        var promise = null;
        promise = await this.init().delete("/account/super_tenants/"+tenantKey.trim()+"/delete");
        return promise;
    };    
	
}

export default new TenantAPI();